// eslint-disable-next-line import/prefer-default-export
export enum TokenValidationFailure {
  EXISTS = 'User already registered',
  INVALID = 'Email and invite code not found',
  EXPIRED = 'Token has expired',
}
